import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { Close, SaveChanges } from "../../../../utils/Constant";
import { CommonModalType } from "../../../../Types/Ui-Kits/UiKitsTypes";
import { Btn, H1, H4, H5 } from "../../../../AbstractElements";
import IconComponent from "../../../../CommonElements/IconComponent";
import "./commonModal.scss";

const CommonModal: React.FC<CommonModalType> = ({
  backdrop,
  centered,
  size,
  isOpen,
  toggle,
  title,
  onClosed,
  sizeTitle,
  fullTitle,
  modalClassName,
  modalBodyClassName,
  children,
  headerClassName,
  titleClassName,
  showFooter = true,
  modalBodyStyle,
  style,
  fade,
  contentClassName,
  showCloseButton = false,
  labelledBy,
}) => {
  return (
    <Modal
      backdrop={backdrop}
      centered={centered}
      size={size}
      fade={fade}
      isOpen={isOpen}
      toggle={toggle}
      onClosed={onClosed}
      className={`${modalClassName}`}
      contentClassName={contentClassName}
      style={style}
      labelledBy={labelledBy}
    >
      {(title || sizeTitle || fullTitle) && (
        <div className={`modal-header ${headerClassName}`}>
          {title && (
            <H5 className={`modal-title ${titleClassName}`}>{title}</H5>
          )}
          {sizeTitle && <H4>{sizeTitle}</H4>}
          {fullTitle && <H1 className="fs-5">{fullTitle}</H1>}
          <Btn className="py-0" close onClick={toggle}></Btn>
        </div>
      )}
      {showCloseButton && (
        <Btn className={`py-0 pointer closeBtnStyle`} onClick={toggle}>
          <IconComponent className="icofont icofont-close pointer f-12" />
        </Btn>
      )}
      <ModalBody
        className={modalBodyClassName ? modalBodyClassName : ""}
        style={modalBodyStyle}
      >
        {children}
      </ModalBody>
      {(title || fullTitle) && showFooter && (
        <ModalFooter>
          <Btn color="secondary" onClick={toggle}>
            {Close}
          </Btn>
          <Btn color="primary">{SaveChanges}</Btn>
        </ModalFooter>
      )}
    </Modal>
  );
};

export default CommonModal;
